import { render } from "./FormTheme.vue?vue&type=template&id=fd33d878&scoped=true"
import script from "./FormTheme.vue?vue&type=script&lang=js"
export * from "./FormTheme.vue?vue&type=script&lang=js"

import "./FormTheme.vue?vue&type=style&index=0&id=fd33d878&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd33d878"]])

export default __exports__